
import ImageHeader from '@/components/core/ImageHeader';

export default {
  scrollToTop: true,
  components: {
    ImageHeader,
  },
  head() {
    return {
      title: "Google Adwords & Social Media Ads-Pay Per Click Services Goa",
      meta: [{
        hid: 'description',
        name: 'description',
        content: 'Advertising Services in Goa by Goa App will get you a notch above the competition with profitable paid search marketing campaigns'
      },
      {
        hid: 'keywords',
        name: 'keywords',
        content: 'pay per click services in goa, pay per click, pay per click marketing, pay per click agency, ppc services in goa, ppc services in india'
      },
      {
        hid: 'og:title',
        property: 'og:title',
        content: 'Google Adwords & Social Media Ads-Pay Per Click Services Goa'
      },
      {
        hid: 'og:description',
        property: 'og:description',
        content: 'Advertising Services in Goa by Goa App will get you a notch above the competition with profitable paid search marketing campaigns'
      },
      {
        hid: 'twitter:title',
        property: 'twitter:title',
        content: 'Google Adwords & Social Media Ads-Pay Per Click Services Goa'
      },
      {
        hid: 'twitter:description',
        property: 'twitter:description',
        content: 'Advertising Services in Goa by Goa App will get you a notch above the competition with profitable paid search marketing campaigns'
      },
      {
        hid: 'og:image:alt',
        property: 'og:image:alt',
        content: 'Google Adwords & Social Media Ads-Pay Per Click Services Goa'
      },
      {
        hid: 'og:image',
        property: 'og:image',
        content: this.$config.siteUrl + '/img/service-imgs/pay-per-click.webp'
      },
      {
        hid: 'image',
        property: 'image',
        content: this.$config.siteUrl + '/img/service-imgs/pay-per-click.webp'
      },
      {
        hid: 'twitter-image',
        property: 'twitter:image',
        content: this.$config.siteUrl + '/img/service-imgs/pay-per-click.webp'
      },

      ],
    }
  },
  scrollToTop: true,
  data() {
    return {
      title: 'Google Adwords & Social Media Ads-Pay Per Click Services Goa',
      description: 'Advertising Services in Goa by Goa App will get you a notch above the competition with profitable paid search marketing campaigns',
      eventCategoryModal: false,
      schemaData: [],

      interLinks: {
        "title": "Explore More Services on Goa App",
        "links": [
          {
            "sub_title": "Top Services",
            "interLinks": [
              {
                "name": "Digital Marketing Services in Goa",
                "url": "/digital-marketing"
              },
              {
                "name": "Website Development in Goa",
                "url": "/website-development"
              },
              {
                "name": "Search Engine Optimization in Goa",
                "url": "/search-engine-optimization"              
		},
              {
                "name": "Advertising in Goa",
                "url": "/Advertising"
              },
              {
                "name": "Graphic Designing in Goa",
                "url": "/graphic-design"
              },
              {
                "name": "Social Media Marketing in Goa",
                "url": "/social-media-marketing"
              },
              {
                "name": "Content Marketing in Goa",
                "url": "/content-marketing"
              }

            ]
          },
        ]
      }
    };
  },

jsonld() {
    return {
        '@context': 'https://schema.org',
        "@graph": [
            {
                "@type": "Service",
                "@id": "https://goa.app/advertising/#Service",
                "url": "https://goa.app/advertising",
                "name": "Advertising",
                "description": "PPC Management services help businesses drive more sales and revenue with successful Pay Per Click Ad Campaigns by our Skilled Experts.",
                "image": "https://goa.app/img/service-imgs/pay-per-click.webp",
                "inLanguage": "en-US",
 	        "datePublished": "2024-06-14T00:00:00",
    	        "dateModified":  "2024-06-14T00:00:00",
                "author": {
                    "@type": "Person",
                    "@id": "https://goa.app",
                    "url": "https://goa.app"
                },
                "serviceType": "Digital Marketing",
                "provider": {
                    "@type": "Corporation",
                    "name": "Goa App",
                    "address": {
                        "@type": "PostalAddress",
                        "addressLocality": "Goa",
                        "postalCode": "403505"
                    },
                    "telephone": "+91 9049248689"
                },
                "priceRange": "$$",
                "hasOfferCatalog": {
                    "@type": "OfferCatalog",
                    "name": "Advertising",
                    "itemListElement": [
                        {
                            "@type": "Offer",
                            "name": "Strategic Approach"
                        },
                        {
                            "@type": "Offer",
                            "name": "Remarketing"
                        },
                        {
                            "@type": "Offer",
                            "name": "Real-time Monitoring"
                        },
                        {
                            "@type": "Offer",
                            "name": "Hyper-Local Targeting"
                        },
                        {
                            "@type": "Offer",
                            "name": "Ecommerce Ads"
                        },
                        {
                            "@type": "Offer",
                            "name": "Google Shopping"
                        },
                        {
                            "@type": "Offer",
                            "name": "Machine Learning"
                        },
                        {
                            "@type": "Offer",
                            "name": "Goal Tracking"
                        },
                        {
                            "@type": "Offer",
                            "name": "Landing Page Management"
                        }
                    ]
                }
            },
            {
                "@type": "FAQPage",
                "mainEntity": [
                    {
                        "@type": "Question",
                        "name": "What are Google Ads (formerly Google Adwords) and how do they work?",
                        "acceptedAnswer": {
                            "@type": "Answer",
                            "text": "Google Ads, now known as Google Ads, is a form of paid digital advertising that allows businesses to display ads on Google's search results. For example, when someone searches for 'Google Adwords Management Goa,' Google Ads may appear at the top with an 'Ad' label. These ads are triggered by specific keywords, and advertisers pay per click (PPC) when users click on them."
                        }
                    },
                    {
                        "@type": "Question",
                        "name": "How much does Pay Per Click Advertising Cost?",
                        "acceptedAnswer": {
                            "@type": "Answer",
                            "text": "When managing your Google Ads campaigns, Goa App charges a management fee for overseeing PPC campaigns. This fee varies based on your brand's size, the range of products and services advertised, targeted channels, and more. Additionally, you'll pay an ad spend directly to Google and Facebook each time your ad is clicked. We determine Cost Per Click (CPC), optimize keywords for search volumes, and aim to maximize ROI while controlling ad spend."
                        }
                    },
                    {
                        "@type": "Question",
                        "name": "How much will it cost me every time someone clicks on my ad?",
                        "acceptedAnswer": {
                            "@type": "Answer",
                            "text": "The cost per click (CPC) varies widely based on industry competitiveness and ad position preferences. Goa App monitors campaigns daily to optimize CPC and enhance ROI, pausing high CPC ads with low conversion rates and accelerating high-performing ones."
                        }
                    },
                    {
                        "@type": "Question",
                        "name": "What does Click Through Rate, Impressions and Ad Positions mean?",
                        "acceptedAnswer": {
                            "@type": "Answer",
                            "text": "Click Through Rate (CTR) measures online ad campaign success, calculated by dividing ad clicks by impressions. Impressions indicate how often ads appear on Google Networks, while Ad Positions determine an ad's placement relative to competitors. Goa App strives to achieve top ad positions for maximum visibility and inquiries."
                        }
                    },
                    {
                        "@type": "Question",
                        "name": "Where else can I show my PPC Ads?",
                        "acceptedAnswer": {
                            "@type": "Answer",
                            "text": "Google is ideal for PPC due to its active user search intent. Goa App also runs PPC campaigns on other search engines like Bing, e-commerce platforms like Amazon and Flipkart, and social media channels like Facebook and Instagram. Each platform targets different customer segments, ensuring comprehensive digital marketing coverage."
                        }
                    },
                    {
                        "@type": "Question",
                        "name": "What should my budget for Google Ads be?",
                        "acceptedAnswer": {
                            "@type": "Answer",
                            "text": "Set your Google Ads budget based on business goals. A higher budget increases ad visibility and potential conversions. Goa App advises on optimal spending aligned with sales targets, market competitiveness, and search volumes, aiming for maximum ROI with scalable ad budgets."
                        }
                    },
                    {
                        "@type": "Question",
                        "name": "Should I pick between SEO and PPC, or do both?",
                        "acceptedAnswer": {
                            "@type": "Answer",
                            "text": "While SEO builds organic search presence over time, PPC provides immediate visibility for customers actively seeking products or services. Combining both strategies allows for comprehensive digital marketing coverage. Goa App manages both SEO and PPC strategies concurrently, optimizing each for long-term growth and immediate results."
                        }
                    }
                ]
            }
        ]
    };
},
 mounted() {
    document.body.classList.add('modalOverflow');

    this.getHomeActitvitesData();
    this.getActitvitesData();
    this.getActitvitesCategoriesData();

    if (localStorage.getItem('recentlyViewed')) {
      this.recentlyViewed = JSON.parse(localStorage.getItem('recentlyViewed'))
    }

    if (localStorage.getItem('activitiesFilter')) {
      localStorage.removeItem('activitiesFilter');
    }
    this.$parent.$emit("sentInterLinks", this.interLinks);
  },

  destroyed() {
    document.body.classList.remove('modalOverflow')
    if (document.getElementById('filterClose'))
      document.getElementById('filterClose').click();
  },

  methods: {
    async getHomeActitvitesData() {
      this.allHomeActivitiesData = await fetch(this.$config.fetchUrl +
        '/api/posts/app/getActivitiesForActivityPageWithSlug').then(res => res
          .text());
      this.allHomeActivitiesData = this.getCryptKey(this.allHomeActivitiesData);
      this.homeactLoading = false;
      this.$nextTick(() => {
        if (this.allHomeActivitiesData) {
          var schemaResult = Object.keys(this.allHomeActivitiesData).map((key) => [this.allHomeActivitiesData[
            key].data]);
          schemaResult = schemaResult.flat(2);
          this.schemaData = [...new Map(schemaResult.map(v => [v.post._id, v])).values()]
        }
      })
      //this.changeThingsToDo(0)
    },

    async getActitvitesData() {
      this.allActivitiesData = await fetch(this.$config.fetchUrl + '/api/coupons/app/featuredCoupons').then(res =>
        res
          .text());
      this.allActivitiesData = this.getCryptKey(this.allActivitiesData);
      this.actLoading = false;
      // this.$nextTick(() => {
      //   if (this.allHomeActivitiesData) {
      //     this.schemaData = [...this.allHomeActivitiesData.featuredActivities, ...this.allHomeActivitiesData.photography, ...this.allHomeActivitiesData.hiddenGems];
      //     this.schemaData = [...new Map(this.schemaData.map(v => [v.post._id, v])).values()]
      //   }
      // })
    },

    async getActitvitesCategoriesData() {
      this.featuredCatsLoading = true;
      this.featuredCats = await fetch(this.$config.fetchUrl + '/api/posts/app/getCategoriesForActivityPageWithSlug').then(res =>
        res
          .text());
      this.featuredCats = this.getCryptKey(this.featuredCats);
      this.featuredCatsLoading = false;
    },

    changeThingsToDo(id) {
      switch (id) {
        case 0:
          this.thingsToDo = this.allHomeActivitiesData.featuredActivities;
          break;
        case 1:
          this.thingsToDo = this.allHomeActivitiesData.photography;
          break;
        case 2:
          this.thingsToDo = this.allHomeActivitiesData.hiddenGems;
          break;
        case 3:
          this.thingsToDo = this.allHomeActivitiesData.specialMoments;
          break;
        case 4:
          this.thingsToDo = this.allHomeActivitiesData.monsoonActivities;
          break;
        default:
          this.thingsToDo = this.allHomeActivitiesData.featuredActivities;
      }
    },

    getSpace(key) {
      return key.replace(/([A-Z])/g, " $1")
    },

    activitiesImage(image) {
      if (image.length > 0) {
        return image[0];
      } else {
        return '';
      }
    },

    // To add a fallback placeholder image if not rendereds from API
    setFallbackImageUrl(event) {
      event.target.src = require(`@/assets/img/placeholders/places.svg`)
    },

    activityVenue(seller) {
      if (seller && seller.length > 0 && seller[0].venue) {
        return seller[0].venue.name
      }
      return ""
    },

    activityDuration(seller) {
      if (seller && seller.length > 0 && seller[0].durationInHours) {
        return seller[0].durationInHours
      }
      return ""
    },

    activityPrice(seller) {
      if (seller && seller.length > 0 && seller[0].tickets && seller[0].tickets.length > 0 && seller[0].tickets[0]
        .prices && seller[0].tickets[0].prices.length > 0 && seller[0].tickets[0].prices[0].strikePrice) {
        return seller[0].tickets[0].prices[0].strikePrice
      }
      return 0
    },

    activityDiscountPrice(seller) {
      if (seller && seller.length > 0 && seller[0].tickets && seller[0].tickets.length > 0 && seller[0].tickets[0]
        .prices && seller[0].tickets[0].prices.length > 0 && seller[0].tickets[0].prices[0].price) {
        return seller[0].tickets[0].prices[0].price
      }
      return 0
    },

    checkIsOffer(seller) {
      let strikePrice = this.activityPrice(seller);
      let price = this.activityDiscountPrice(seller);
      if (strikePrice > price) {
        return true
      }
      return false
    },

    offerPercentage(seller) {
      if (this.checkIsOffer(seller)) {
        let strikePrice = this.activityPrice(seller);
        let price = this.activityDiscountPrice(seller);
        let offerPercentage = strikePrice - price;
        if (offerPercentage > 0) {
          return ((100 * (strikePrice - price) / strikePrice) > 0 && (100 * (strikePrice - price) /
            strikePrice) < 100) ? parseFloat((100 * (strikePrice - price) / strikePrice).toFixed(0)) : 0
        } else return 0
      }
      return 0
    },

    categoryBtnClicked(item) {
      if (item) {
        this.$router.push({
          path: item
        })
      }
    },

  }
}
